import type { ReactNode } from "react";
import type { Id, OrderListItem } from "../../types";
import OrdersGrid from "./OrdersGrid";
import OrdersTable from "./OrdersTable";

interface OrdersListSectionProps {
  orders: OrderListItem[];
  selectedOrderId: Id | null;
  orderDetailsLoading: boolean;
  onShowDetails: (order: OrderListItem) => void;
  resolveOrderDetailId: (order: OrderListItem) => Id | null;
  getOrderKey: (order: OrderListItem) => string;
  formatOrderLabel: (order: OrderListItem) => string;
  formatDateTime: (value?: string) => string;
  formatDate: (value?: string) => string;
  formatCurrency: (value?: number | null) => string;
  getOrderStatusLabel: (order: OrderListItem) => string;
  pagination?: ReactNode;
}

const OrdersListSection = ({
  orders,
  selectedOrderId,
  orderDetailsLoading,
  onShowDetails,
  resolveOrderDetailId,
  getOrderKey,
  formatOrderLabel,
  formatDateTime,
  formatDate,
  formatCurrency,
  getOrderStatusLabel,
  pagination,
}: OrdersListSectionProps) => (
  <>
    <OrdersGrid
      orders={orders}
      selectedOrderId={selectedOrderId}
      orderDetailsLoading={orderDetailsLoading}
      className="orders-cards"
      onShowDetails={onShowDetails}
      resolveOrderDetailId={resolveOrderDetailId}
      getOrderKey={getOrderKey}
      formatOrderLabel={formatOrderLabel}
      formatDateTime={formatDateTime}
      formatDate={formatDate}
      formatCurrency={formatCurrency}
      getOrderStatusLabel={getOrderStatusLabel}
    />
    <div className="orders-table" role="region" aria-live="polite">
      <OrdersTable
        orders={orders}
        selectedOrderId={selectedOrderId}
        orderDetailsLoading={orderDetailsLoading}
        onShowDetails={onShowDetails}
        resolveOrderDetailId={resolveOrderDetailId}
        getOrderKey={getOrderKey}
        formatOrderLabel={formatOrderLabel}
        formatDateTime={formatDateTime}
        formatDate={formatDate}
        formatCurrency={formatCurrency}
        getOrderStatusLabel={getOrderStatusLabel}
      />
    </div>
    {pagination}
  </>
);

export default OrdersListSection;
